import React from 'react';

import { Icon } from '@components/atoms';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { TimePicker as ATimePicker, TimePickerProps, TimeRangePickerProps } from 'antd';

const { RangePicker } = ATimePicker;

export interface ITimePickerParams extends TimePickerProps {
  fullWidth?: boolean;
}

export interface ITimeRangePickerParams extends TimeRangePickerProps {
  fullWidth?: boolean;
}

const isPropValid = (props: any) => props !== 'fullWidth';

const StyledTimePicker = styled(ATimePicker, { shouldForwardProp: isPropValid })<ITimePickerParams>`
  height: 36px !important;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  ${({ disabled, theme }) =>
    disabled &&
    css`
      svg path,
      svg g {
        stroke: ${theme.gray5} !important;
      }
    `}
`;

export const TimePicker = ({ ...rest }: ITimePickerParams) => (
  <StyledTimePicker suffixIcon={<Icon icon="ico16Time" />} {...rest} />
);

const StyledTimeRangePicker = styled(RangePicker, { shouldForwardProp: isPropValid })<ITimeRangePickerParams>`
  height: 36px !important;
  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  ${({ disabled, theme }) =>
    disabled &&
    css`
      svg path,
      svg g {
        stroke: ${theme.gray5} !important;
      }
      input::placeholder {
        color: ${theme.gray4} !important;
      }
    `}
  .ant-picker-range-separator {
    top: -6px !important;
    position: relative !important;
  }
  .anticon.anticon-swap-right {
    display: none;
  }
  .ant-picker-range-separator:after {
    content: '~';
    font-size: 16px;
    color: ${({ theme }) => theme.gray5};
    ${({ disabled, theme }) =>
      disabled &&
      css`
        color: ${theme.gray4} !important;
      `}
    padding-left: 3px;
  }
`;

export const TimeRangePicker = ({ ...rest }: ITimeRangePickerParams) => (
  <StyledTimeRangePicker suffixIcon={<Icon icon="ico16Time" />} {...rest} />
);
